import Airdrop from "@/components/layout/home/Airdrop";
import Levels from "@/components/layout/network/Levels";
import ReferralLink from "@/components/layout/network/ReferralLink";
import Sponsor from "@/components/layout/network/Sponsor";
import Statistics from "@/components/layout/network/Statistics";

const Network = () => {
  return (
    <div className="flex flex-col justify-between items-center gap-3 px-4">
      <div className="w-full flex flex-col gap-2">
        <ReferralLink />
        <Airdrop />
        <Statistics />
      </div>

      <div className="w-full flex flex-col gap-2">
        <Sponsor />

        <Levels />
      </div>
    </div>
  );
};

export default Network;
